import { render, staticRenderFns } from "./StatementOfFaith.vue?vue&type=template&id=194d8738&"
import script from "./StatementOfFaith.vue?vue&type=script&lang=js&"
export * from "./StatementOfFaith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports